import script from "./HelmOpTargetTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelmOpTargetTab.vue?vue&type=script&setup=true&lang=ts"

import "./HelmOpTargetTab.vue?vue&type=style&index=0&id=ce20811a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce20811a"]])

export default __exports__